module.exports = __webpack_public_path__ + "img/logo.e1575812.png";